var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6016 6.10104L3.56594 6.10104L7.95035 1.71434C8.30074 1.36377 8.30074 0.788461 7.95035 0.437884C7.59995 0.0873079 7.03393 0.0873079 6.68354 0.437884L0.762794 6.36172C0.412401 6.7123 0.412401 7.27861 0.762794 7.62919L6.67455 13.562C7.02495 13.9126 7.59097 13.9126 7.94136 13.562C8.29175 13.2114 8.29175 12.6451 7.94136 12.2946L3.56594 7.89886L13.6016 7.89886C14.0957 7.89886 14.5 7.49435 14.5 6.99995C14.5 6.50555 14.0957 6.10104 13.6016 6.10104Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.285c6e4a2b7ae5f8697c6d0815f581e6.svg";
export { ForwardRef as ReactComponent };